var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    [
      _c("h3", [_vm._v(" Mon compte ")]),
      _c("section", { staticClass: "mb-3" }, [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-md-12" }, [
            _vm._m(0),
            _c(
              "div",
              { staticClass: "alert alert-light" },
              _vm._l(_vm.endusers, function(enduser, indexEnduser) {
                return _c("div", { key: indexEnduser, staticClass: "mb-4" }, [
                  _c("h6", [
                    _vm._v(
                      "Code pour le Kit Emotivi de " +
                        _vm._s(enduser.en_fullname)
                    )
                  ]),
                  _c("span", { staticClass: "referral-code" }, [
                    _vm._v(" " + _vm._s(enduser.en_referral_code) + " ")
                  ])
                ])
              }),
              0
            )
          ])
        ])
      ]),
      _vm.row_co.co_id
        ? _c("form-contact", { attrs: { row_co: _vm.row_co } })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "d-flex flex-row w-100 mb-2" }, [
      _c("h4", { staticClass: "flex-grow-1 mb-0" }, [
        _vm._v(" Programme de parrainage ")
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }